import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Card,
  CardContent,
  CardMedia,
  Grid2,
  styled,
  Typography,
  Box,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import styles from "./BlogCard.module.scss";
import Author from "../Author/Author";

const StyledCard = styled(Card)({
  display: "flex",
  flexDirection: "column",
  padding: 0,
  height: "100%",
  "&:hover": {
    backgroundColor: "transparent",
    cursor: "pointer",
  },
  "&:focus-visible": {
    outline: "3px solid",
    outlineColor: "hsla(210, 98%, 48%, 0.5)",
    outlineOffset: "2px",
  },
});
const StyledCardContent = styled(CardContent)({
  display: "flex",
  flexDirection: "column",
  padding: 0,
  gap: 4,
  flexGrow: 1,
});
const StyledTypography = styled(Typography)({
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 8,
  overflow: "hidden",
  textOverflow: "ellipsis",
});
const BlogCard = ({
  slug = "",
  index = "",
  title = "",
  tag = "",
  authors = [],
  path = "blogs",
  state = "",
  district = "",
  shortDescription = "",
  locationLink = "",
  coverImage = "",
}) => {
  const {
    i18n: { language },
  } = useTranslation();

  const navigator = useNavigate();
  const [focusedCardIndex, setFocusedCardIndex] = useState(null);
  const handleFocus = (index) => {
    setFocusedCardIndex(index);
  };

  const handleBlur = () => {
    setFocusedCardIndex(null);
  };
  return (
    <Grid2
      onClick={() => {
        navigator(`/${path}/${slug}`);
      }}
      size={{ xs: 12, md: 4 }}
      className={styles.cardGrid}
    >
      <StyledCard
        variant="outlined"
        onFocus={() => handleFocus(index)}
        onBlur={handleBlur}
        tabIndex={0}
        className={`${styles.styledCard} ${
          focusedCardIndex === index ? "Mui-focused" : ""
        }`}
      >
        <CardMedia
          component="img"
          alt={`${title?.en || title?.hi || ""} image`}
          image={coverImage}
          className={styles.cardMedia}
          loading="lazy"
        />

        <div className={styles.cardContentContainer}>
          <StyledCardContent className={styles.cardContent}>
            <Typography
              gutterBottom
              variant="h6"
              component="div"
              className={styles.cardTitle}
            >
              {title?.[language] ? title?.[language] : ""}
            </Typography>

            <div className="q1-editor">
              <StyledTypography
                variant="body2"
                color="text.secondary"
                gutterBottom
                dangerouslySetInnerHTML={{
                  __html: shortDescription?.[language]
                    ? shortDescription?.[language]
                    : "",
                }}
              ></StyledTypography>
            </div>
            <Typography gutterBottom variant="caption" component="div">
              {tag}
            </Typography>
          </StyledCardContent>

          {path === "blogs" ? (
            <Author author={authors?.[0]} showInCard={true} />
          ) : (
            <Box className={styles.locationContent}>
              <LocationOnIcon
                fontSize="small"
                color="action"
                sx={{ cursor: locationLink ? "pointer" : "inherit" }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (locationLink) {
                    window.open(locationLink, "_blank");
                  }
                }}
              />
              {district?.name?.[language]} - {state?.name?.[language]}
            </Box>
          )}
        </div>
      </StyledCard>
    </Grid2>
  );
};

export default BlogCard;
